import React, { useState } from 'react';

const semifinalists = [
  "Vayun C.", "Aarush K.", "Akshay K.", "Vishnu M.", "Antara C.", "Prashanth G.",
  "Anisha P.", "Ameya S.", "Moeen M.", "Platon G.", "Katherine C.", "Artem K.",
  "Arish S.", "Adhrith V.", "Likhith K", "Sarthak K.", "Ram S.", "Sakethram R.",
  "Anya C.", "Chegu V.", "Nikhita B.", "Elaab T.", "Trashgim M.", "Neo R.",
  "Youngjae S.", "Ishaan G.", "Rania R.", "Amit B.", "Stanley H.", "Shang-Jiun E.",
  "Areej A.", "Alyssa Y.", "Elizabeth H.", "Justin Y.", "Abigail R.", "Bethelehem K.",
  "Amritha P.", "Salman A.", "Twisha H.", "Keisha K.", "Hakim S.", "Lesbek A.",
  "Aadi S.", "Abhimanyu C.", "Raksha K.", "Andrew Z.", "Sungwoo C.", "Shayaan U.",
  "Siddharth T.", "Aditya L.", "Shreyaan C.", "Seraph Y.", "Egor C.", "Elan S.",
  "Nicholas R.", "Jason Y.", "Prakriti A.", "Serena D.", "Lasya P.", "Michael Q.",
  "Yi L.", "Caiman M.", "Jumanah M.", "Surdish R.", "Madhavendra T.", "Yifeng C.",
  "Pavi J.", "Eeshaan V.", "Aryan S.", "Nandita M.", "Saathvik V.", "Arnav E.",
  "Nainika S.", "Klara M.", "Atul G.", "Samyra M.", "Sai C.", "Siddharth S.",
  "Oscar M.", "Rohith L.", "Sreeram B.", "Arav C.", "Sriya G.", "Amogh B.",
  "Rajat R.", "Hongyi W.", "Rudransh P.", "Evan H.", "Ethan S.", "Saahir V.",
  "Shivaani A.", "Sritam P.", "Esther L.", "Aditya K.", "Alex Z.", "Nayan P.",
  "Kenisha V.", "Claire C.", "Om S.", "Jaansi P.", "Vineet S.", "Hayden R.",
  "Nina Z.", "Avani A.", "Tanvi G.", "Roshini S.", "Angel Z.", "Narendran K.",
  "William L.", "Sophia H.", "Aarish T.", "Ximurong Z.", "Hafsah M.", "Nassar B.",
  "Pradhyumna V.", "Alicia Z.", "Conor M.", "Shivansh B.", "Azimullah R.", "Shaan D.",
  "Devaki R.", "Ansh J.", "Anishka V.", "Pratyay A.", "Kshithi P.", "Adwita N.",
  "Radia M.", "Tristan P.", "Vishwa V.", "Zhangir M.", "Keshav W.", "Carlos M.",
  "Ruuhan A.", "Anshi M.", "Shiven D.", "Akash K.", "Hridhaan S.", "Sara W.",
  "Grace L.", "Nguyen H.", "Edward K.", "Aradhya V.", "Navya K.", "Tanisha S.",
  "Akhil P.", "Soneesh K.", "Medha K.", "Ishaan P.", "Yuvha K.", "Tyler L."
];

function Winners() {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNames = semifinalists.filter(name =>
    name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      {/* Header Section */}
      <div style={{ marginBottom: '40px' }}>
        <span style={{
          display: 'inline-block',
          padding: '6px 14px',
          borderRadius: '6px',
          backgroundColor: 'rgba(0, 77, 153, 0.08)',
          color: '#004d99',
          fontSize: '0.85rem',
          fontWeight: '600',
          marginBottom: '16px'
        }}>
          March 29, 2024
        </span>
        <h2 style={{
          fontSize: '2rem',
          fontWeight: '600',
          color: '#1a1a2e',
          marginBottom: '8px'
        }}>
          2024 Semi-Finalists
        </h2>
        <p style={{ fontSize: '1rem', color: '#004d99', fontWeight: '600', marginBottom: '16px' }}>
          Semifinalists - Top 15%
        </p>
        <p style={{ fontSize: '1.2rem', color: '#1a1a2e', fontWeight: '600', marginBottom: '16px' }}>
          International Research Olympiad Semi-Finalists Announced.
        </p>
        <p style={{ fontSize: '1.05rem', color: '#555', lineHeight: '1.7', marginBottom: '16px' }}>
          <strong>Congratulations to the IRO semi-finalists.</strong>
        </p>
      </div>

      {/* Quote Card */}
      <div style={{
        background: '#f8f9fa',
        borderRadius: '16px',
        padding: '32px',
        marginBottom: '40px',
        borderLeft: '4px solid #004d99'
      }}>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '12px' }}>
          "We believe your potential in research is unlimited and deep. We stand committed to making this community into a close, innovative, welcoming, and supportive society around student research aspirations."
        </p>
        <p style={{ fontSize: '0.95rem', color: '#1a1a2e', fontWeight: '600', margin: 0 }}>
          — Rishab Jain, Student Board Member & President, IRO
        </p>
      </div>

      {/* Description */}
      <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.8', marginBottom: '40px', textAlign: 'center', maxWidth: '800px', margin: '0 auto 40px auto' }}>
        The International Research Olympiad is a platform that strives to create and promote research culture among high school students. This is done by providing a variety of services, tools, and support that aim to streamline the research process. The IRO seeks to give students the opportunity to develop their research proficiency, learn new methodologies, and collaborate at an international scale.
      </p>

      {/* Stats */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            {semifinalists.length}
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Semi-Finalists</p>
        </div>
        <div style={{
          background: '#fff',
          borderRadius: '12px',
          padding: '24px 32px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e8eef3',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            color: '#004d99',
            margin: '0 0 4px 0',
            lineHeight: '1'
          }}>
            Top 15%
          </p>
          <p style={{ fontSize: '0.9rem', color: '#666', margin: 0 }}>Of All Participants</p>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search for a name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '14px 20px',
            fontSize: '1rem',
            border: '1px solid #e8eef3',
            borderRadius: '10px',
            outline: 'none',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => e.target.style.borderColor = '#004d99'}
          onBlur={(e) => e.target.style.borderColor = '#e8eef3'}
        />
      </div>

      {/* Names Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: '12px'
      }}>
        {filteredNames.map((name, index) => (
          <div key={index} style={{
            background: '#fff',
            borderRadius: '8px',
            padding: '14px 18px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
            border: '1px solid #e8eef3',
            fontSize: '0.95rem',
            color: '#1a1a2e',
            fontWeight: '500'
          }}>
            {name}
          </div>
        ))}
      </div>

      {filteredNames.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '40px' }}>
          No results found for "{searchTerm}"
        </p>
      )}
    </div>
  );
}

export default Winners
